export const appBuildAssetsDir = "assets"

export const appHead = {"meta":[{"name":"author","content":"Monito"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"}],"link":[{"key":"icon16","rel":"icon","type":"image/png","href":"/favicons/favicon-16x16.png","sizes":"16x16"},{"key":"icon32","rel":"icon","type":"image/png","href":"/favicons/favicon-32x32.png","sizes":"32x32"},{"key":"icon96","rel":"icon","type":"image/png","href":"/favicons/favicon-96x96.png","sizes":"96x96"},{"key":"icon128","rel":"icon","type":"image/png","href":"/favicons/favicon-128x128.png","sizes":"128x128"},{"key":"icon196","rel":"icon","type":"image/png","href":"/favicons/favicon-196x196.png","sizes":"196x196"},{"key":"appleIcon57","rel":"apple-touch-icon","href":"/favicons/apple-touch-icon-57x57.png","sizes":"57x57"},{"key":"appleIcon60","rel":"apple-touch-icon","href":"/favicons/apple-touch-icon-60x60.png","sizes":"60x60"},{"key":"appleIcon72","rel":"apple-touch-icon","href":"/favicons/apple-touch-icon-72x72.png","sizes":"72x72"},{"key":"appleIcon76","rel":"apple-touch-icon","href":"/favicons/apple-touch-icon-76x76.png","sizes":"76x76"},{"key":"appleIcon114","rel":"apple-touch-icon","href":"/favicons/apple-touch-icon-114x114.png","sizes":"114x114"},{"key":"appleIcon120","rel":"apple-touch-icon","href":"/favicons/apple-touch-icon-120x120.png","sizes":"120x120"},{"key":"appleIcon144","rel":"apple-touch-icon","href":"/favicons/apple-touch-icon-144x144.png","sizes":"144x144"},{"key":"appleIcon152","rel":"apple-touch-icon","href":"/favicons/apple-touch-icon-152x152.png","sizes":"152x152"},{"rel":"preconnect","href":"https://www.google-analytics.com"},{"rel":"dns-prefetch","href":"https://cdn.sanity.io"},{"rel":"dns-prefetch","href":"https://monito.imgix.net"}],"style":[],"script":[],"noscript":[],"title":"Monito"}

export const appCdnURL = "https://static.monito.com"

export const appBaseURL = "/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true